module.exports = __webpack_public_path__ + "img/matchmaking-handshake.8eae6c59.jpg";